import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from "@/serviceWorkerRegistration";

// Prevent non-fatal ResizeObserver loop warnings during rapid popover/dialog layout changes.
const NativeResizeObserver = window.ResizeObserver;
if (NativeResizeObserver) {
  window.ResizeObserver = class ResizeObserverPatched extends NativeResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

const RO_LOOP_MSG = "ResizeObserver loop completed with undelivered notifications.";
window.addEventListener(
  "error",
  (event) => {
    if (event?.message === RO_LOOP_MSG) {
      event.stopImmediatePropagation();
    }
  },
  true,
);

if (
  window.matchMedia("(display-mode: standalone)").matches
  || window.navigator.standalone === true
) {
  document.documentElement.classList.add("pwa-standalone");
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// App mounted — clear shell-recovery flag and drop cache-bust query from the URL.
try {
  sessionStorage.removeItem("bcpl_shell_reload");
  const u = new URL(window.location.href);
  if (u.searchParams.has("_bcpl")) {
    u.searchParams.delete("_bcpl");
    const clean = `${u.pathname}${u.search}${u.hash}`;
    window.history.replaceState({}, "", clean);
  }
} catch {
  /* ignore */
}

serviceWorkerRegistration.registerPushServiceWorker();
serviceWorkerRegistration.startBuildUpdateWatcher();
